//import React from "react";

const Footer = () => {
    return(
            <footer id="footer">
                <div class="footer-top">
                    <div class="container">
                        <div class="row">
                            <div className="col-lg-4 col-md-6 footer-contact">
                                <h3>KPA Structure</h3>
                                <p>2547 Newland Avenue <br/>Brooklyn, NY 11234<br/>
                                United States <br/><br/>
                                <strong>Phone:</strong> +1 (718) 814-8229<br/>
                                <strong>Email:</strong> saady.a@kpa-structure.team<br/>
                                <strong>Whatsapp:</strong> +1 (302) 641-1780<br/>
                                </p>
                            </div>
                            <div class="col-lg-4 col-md-6 footer-links">
                                <h4>Useful Links</h4>
                                <ul>
                                    <li><i class="bx bx-chevron-right"></i> <a href="/">Home</a></li>
                                    <li><i class="bx bx-chevron-right"></i> <a href="/about-us">About us</a></li>
                                    <li><i class="bx bx-chevron-right"></i> <a href="/team">Terms of service</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container d-md-flex py-4">
                    <div class="me-md-auto text-center text-md-start">
                        <div class="copyright">
                            &copy; Copyright by <strong><span>KPA Structure</span></strong>. All Rights Reserved
                        </div>
                    <div class="credits"></div>
                </div>
            </div>
        </footer>
    )

};

export default Footer;